import { Injectable } from "@angular/core";
import { HttpHandlerService } from "../../http-handler.service";
import { environment } from "src/environments/environment";
import { AppTokenService } from "../../app-token.service";
import { Observable } from "rxjs";

@Injectable()

export class DiscountService {
    _httpHandler: HttpHandlerService;
    _apiUrl = environment.apiUrl;
    _resourceEndPoint = 'discount';

    constructor(private httpHandler: HttpHandlerService, private appTokenService: AppTokenService) {
        this._httpHandler = httpHandler;
    }

    public uploadDiscount(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public getAllPeriodInfo(): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}/periods`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public getDiscountInfoByPeriod(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}/info/${id}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public DeleteDiscountPeriodById(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}/periods/${id}`;
        const request_option = this._httpHandler.prepareRequest(
            'DELETE',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public Upload_Delete(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}/info/${id}`;
        const request_option = this._httpHandler.prepareRequest(
            'DELETE',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public checkDiscountPeriod(requestObj: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}/periods/check`
        const request_option = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            requestObj
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public UpdateDiscountPeriodById(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}/period`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            userData
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public UpdateDiscountInfoById(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}/info`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            userData
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }


}